import ChartAPI from "../../apps/common/chart-api";

import {shortenizeYearFormat} from "./tools/tools";

// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
  m[i] =
    m[i] ||
    function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
  m[i].l = 1 * new Date();
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) {
      return;
    }
  }
  (k = e.createElement(t)),
    (a = e.getElementsByTagName(t)[0]),
    (k.async = 1),
    (k.src = r),
    a.parentNode.insertBefore(k, a);
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
});

const topPositionTypeOptions = [
  {
    title: "Да",
    value: true,
  },
  {
    title: "Нет",
    value: false,
  },
];

const defaultTopPositionTypeOption = {
  title: "Да",
  value: true,
};

const meanPositionTypeOptions = [
  {
    title: "Больше",
    value: "mean_position_gt",
  },
  {
    title: "Меньше",
    value: "mean_position_lt",
  },
];

const defaultMeanPositionTypeOption = {
  title: "Больше",
  value: "mean_position_gt",
};

export default {
  namespaced: true,
  state: {
    reportsRows: [],
    keywordsStats: {},
    keywordsStatsComparing: {},
    reportsRowsTitles: [],
    reportRowsDates: [],
    sliceParams: [],
    slice: null,
    keywordsStatsPeriod: "",
    loadingTable: false,
    topPersistenceFilterType: {
      title: "Больше",
      value: "results_in_top_gt",
    },
    topPersistenceFilterTypeOptions: [
      {
        title: "Больше",
        value: "results_in_top_gt",
      },
      {
        title: "Меньше",
        value: "results_in_top_lt",
      },
    ],
    topPersistenceFilterValue: "",
    filterByOptions: [
      {
        title: "Средняя позиция",
        value: "mean_position",
      },
      {
        title: "В топ-3",
        value: "in_top_3",
      },
      {
        title: "В топ-10",
        value: "in_top_10",
      },
    ],
    filterBy: {
      title: "Средняя позиция",
      value: "mean_position",
    },
    onePeriod: null,
    onePeriodValue: null,
    resetStatus: false,
    tableThumblersHolding: false,
    paginationPageNumber: 1,
    pageItems: 1,
    currentPaginationPage: 1,
    rowsPaginationNumber: 1,
    downloadKeywordsOrganicLink: [],
    firstAdvertiser: null,
    comparingValueTable: true,
    slicePaginationPage: {},
    //        slicePaginationPageNumber: {}
  },
  actions: {
    async fetchKeywordsOrganicStats(
      { commit, dispatch, getters, rootGetters },
      onePeriodAndSlicing = [null, null, null, null]
    ) {
      commit("updateReportsRows", []);
      commit("updateReportsRowsTitles", []);
      commit("updateReportRowsDates", []);
      commit("updateDownloadKeywordsOrganicLink", []);
      commit("updateReport", {});
      commit("updateReportComparing", {});
      commit("updateSlice", null);
      commit("updateLoadingTable", true);
      commit("updateFilterBy", getters["filterBy"]);
      commit(
        "updateTopPersistenceFilterType",
        getters["topPersistenceFilterType"]
      );
      commit("updateSlice", rootGetters["filters/slice"]);
      commit("updateOnePeriod", onePeriodAndSlicing[0]);
      let paginationPage = 1;
      let slicePaginationPageNumber = {};
      if (onePeriodAndSlicing[1] === null) {
        commit("updateSlicePagination", {});
        paginationPage = `&page=${getters["currentPaginationPage"]}`;
      } else {
        paginationPage = "";
      }

      let rootGettersAdvertisersParam = rootGetters["filters/advertisersParam"];
      let advertiser = "";
      let resetProjectAdvertiser =
        JSON.parse(localStorage.getItem("resetProjectAdvertiser")) ||
        JSON.parse(sessionStorage.getItem("resetProjectAdvertiser")) ||
        null;
      let resetProjectAdvertiserAnother =
        JSON.parse(localStorage.getItem("resetProjectAdvertiser")) ||
        JSON.parse(sessionStorage.getItem("resetProjectAdvertiser")) ||
        null;
      if (
        resetProjectAdvertiser !== null ||
        resetProjectAdvertiserAnother !== null
      ) {
        rootGettersAdvertisersParam = "";
        if (resetProjectAdvertiser !== null) {
          advertiser += `&advertiser=${resetProjectAdvertiser["id"]}`;
        } else {
          advertiser += `&advertiser=${resetProjectAdvertiserAnother["id"]}`;
        }
        this.onePeriod = true;
        localStorage.removeItem("resetProjectAdvertiser");
        sessionStorage.removeItem("resetProjectAdvertiser");
      }
      let currentProject = getters["firstAdvertiser"];
      let currentProjectAdvertiser =
        JSON.parse(localStorage.getItem("firstProjectAdvertiser")) ||
        JSON.parse(sessionStorage.getItem("firstProjectAdvertiser")) ||
        null;
      let currentProjectAdvertiserAnother =
        JSON.parse(localStorage.getItem("firstProjectAdvertiser")) ||
        JSON.parse(sessionStorage.getItem("firstProjectAdvertiser")) ||
        null;
      if (
        rootGetters["filters/advertisersFilter"] === null &&
        (currentProjectAdvertiser !== null ||
          currentProjectAdvertiserAnother !== null) &&
        resetProjectAdvertiser === null &&
        resetProjectAdvertiserAnother === null
      ) {
        if (currentProjectAdvertiserAnother !== null) {
          advertiser += `&advertiser=${currentProjectAdvertiserAnother["id"]}`;
        } else if (currentProjectAdvertiser !== null) {
          advertiser += `&advertiser=${currentProjectAdvertiser["id"]}`;
        } else {
          advertiser += `&advertiser=${currentProject["id"]}`;
        }
      }
      let filterMainPeriod = "&filter_main_period=false";
      let filterMainPeriodTrue = "&filter_main_period=true";
      if (getters["comparingValueTable"]) {
        filterMainPeriod = filterMainPeriodTrue;
      }
      let studObj = new ChartAPI();
      let dateRangeString = rootGetters["filters/dateRangeParam"];
      let dateRange = rootGetters["filters/dateRangeString"]
        .replaceAll(" ", "")
        .replace("-", " - ");
      let dateRangeComparingString =
        rootGetters["filters/dynamicDashboardParams"];
      let dateRangeComparing = rootGetters["filters/dateRangeComparingString"]
        .replaceAll(" ", "")
        .replace("-", " - ");
      commit("updateSliceParams", []);
      // commit("updateCurrentPaginationPage", getters['paginationPageNumber'])
      const slicePageItems = 25;
      const noSlicePageItems = 50;
      if (rootGetters["filters/slice"]) {
        commit("updatePageItems", slicePageItems);
        let slice = rootGetters["filters/slice"]["value"];
        let reportsParams = [];
        // splitting query parameters into slices, if necessary
        if (slice === "src") {
          ["yandex", "google"].forEach((elem) => {
            if (onePeriodAndSlicing[1] === null) {
              commit("updateCurrentSlicePaginationPage", [
                elem.toLowerCase(),
                1,
              ]);
            }
            reportsParams.push({
              slice_param: elem.toLowerCase(),
              slice_url: `&engine=${elem}`,
              query: [
                `&engine=${elem}` +
                  rootGetters["filters/deviceTypesParam"] +
                  rootGetters["filters/keywordsTypesParam"] +
                  rootGetters["filters/geoLocationsParam"] +
                  rootGetters["filters/keywordsParam"] +
                  rootGettersAdvertisersParam +
                  rootGetters["keywords_organic/filterTableLink"] +
                  `&page=${getters["slicePaginationPage"][elem]}`,
              ],
            });
          });
        } else if (slice === "dsl") {
          ["true", "false"].forEach((elem) => {
            let newElem = (
              elem === "true" ? "Desktop" : "Mobile"
            ).toLowerCase();
            if (onePeriodAndSlicing[1] === null) {
              commit("updateCurrentSlicePaginationPage", [newElem, 1]);
            }
            reportsParams.push({
              slice_param: newElem,
              slice_url: `&is_desktop=${elem}`,
              query: [
                `&is_desktop=${elem}` +
                  rootGetters["filters/searchEngineParam"] +
                  rootGetters["filters/keywordsTypesParam"] +
                  rootGetters["filters/geoLocationsParam"] +
                  rootGetters["filters/keywordsParam"] +
                  rootGettersAdvertisersParam +
                  rootGetters["keywords_organic/filterTableLink"] +
                  `&page=${getters["slicePaginationPage"][newElem]}`,
              ],
            });
          });
        } else if (slice === "kwt") {
          if (rootGetters["filters/keywordsTypes"].length) {
            rootGetters["filters/keywordsTypes"].forEach((elem) => {
              if (onePeriodAndSlicing[1] === null) {
                commit("updateCurrentSlicePaginationPage", [
                  elem["title"].toLowerCase(),
                  1,
                ]);
              }
              reportsParams.push({
                slice_param: elem["title"].toLowerCase(),
                slice_url: `&kw_type=${elem["value"]}`,
                query: [
                  `&kw_type=${elem["value"]}` +
                    rootGetters["filters/searchEngineParam"] +
                    rootGetters["filters/geoLocationsParam"] +
                    rootGetters["filters/deviceTypesParam"] +
                    rootGetters["filters/keywordsParam"] +
                    rootGettersAdvertisersParam +
                    rootGetters["keywords_organic/filterTableLink"] +
                    `&page=${getters["slicePaginationPage"][elem]}`,
                ],
              });
            });
          } else {
            if (rootGetters["filters/optionsKeywordsTypes"]) {
              rootGetters["filters/optionsKeywordsTypes"].forEach((elem) => {
                if (onePeriodAndSlicing[1] === null) {
                  commit("updateCurrentSlicePaginationPage", [
                    elem["title"].toLowerCase(),
                    1,
                  ]);
                }
                reportsParams.push({
                  slice_param: elem["title"].toLowerCase(),
                  slice_url: `&kw_type=${elem["value"]}`,
                  query: [
                    `&kw_type=${elem["value"]}` +
                      rootGetters["filters/searchEngineParam"] +
                      rootGetters["filters/geoLocationsParam"] +
                      rootGetters["filters/deviceTypesParam"] +
                      rootGetters["filters/keywordsParam"] +
                      rootGettersAdvertisersParam +
                      rootGetters["keywords_organic/filterTableLink"] +
                      `&page=${
                        getters["slicePaginationPage"][
                          elem["title"].toLowerCase()
                        ]
                      }`,
                  ],
                });
              });
            }
          }
        } else if (slice === "ggr") {
          if (rootGetters["filters/optionsGeoLocation"]) {
            rootGetters["filters/optionsGeoLocation"].forEach((elem) => {
              if (onePeriodAndSlicing[1] === null) {
                commit("updateCurrentSlicePaginationPage", [
                  elem["name"].toLowerCase(),
                  1,
                ]);
              }
              reportsParams.push({
                slice_param: elem["name"].toLowerCase(),
                slice_url: `&geolocation_tag=${elem["id"]}`,
                query: [
                  `&geolocation_tag=${elem["id"]}` +
                    rootGetters["filters/searchEngineParam"] +
                    rootGetters["filters/keywordsTypesParam"] +
                    rootGetters["filters/deviceTypesParam"] +
                    rootGetters["filters/keywordsParam"] +
                    rootGettersAdvertisersParam +
                    rootGetters["keywords_organic/filterTableLink"] +
                    `&page=${
                      getters["slicePaginationPage"][elem["name"].toLowerCase()]
                    }`,
                ],
              });
            });
          }
        } else {
          if (slicePaginationType[1] === null) {
            commit("updateCurrentSlicePaginationPage", [null, 1]);
          }
          reportsParams.push({
            slice_param: null,
            slice_url: null,
            query: [
              rootGetters["filters/geoLocationsParam"] +
                rootGetters["filters/searchEngineParam"] +
                rootGetters["filters/keywordsTypesParam"] +
                rootGetters["filters/deviceTypesParam"] +
                rootGetters["filters/keywordsParam"] +
                rootGettersAdvertisersParam +
                rootGetters["keywords_organic/filterTableLink"] +
                `&page=${getters["slicePaginationPage"][elem]}`,
            ],
          });
        }
        // add second request with another date for every report if comparing is enabled
        let is_comparing = rootGetters["filters/comparingState"];
        let reportSlice = [];
        for (const params of reportsParams) {
          let tableTitle = ["Статистика по ключевым словам", "за период "];
          let rowDate = [];
          let dateRangeModified = dateRange;
          if (is_comparing) {
            dateRangeModified = `${dateRange.slice(0, 5)} -${dateRange.slice(
              12
            )}`;
          }
          let sliceParam = `${params.slice_param
            .charAt(0)
            .toUpperCase()}${params.slice_param.slice(1)}`;
          if (!is_comparing) {
            let jsonResponse = await studObj.sendRequest(
              "getOrganicKeywords",
              rootGetters["currentProjectId"],
              "?" +
                dateRangeString +
                "&is_sliced_data=true" +
                params.query.join() +
                filterMainPeriodTrue +
                advertiser
            );
            let keywordDownloadLink = `${
              rootGetters["currentProjectId"]
            }?${dateRangeString}&is_sliced_data=true&page=${
              getters["currentPaginationPage"]
            }${params.query.join()}${filterMainPeriodTrue}`;
            commit("updatePushKeywordsOrganicLink", keywordDownloadLink);
            if (jsonResponse !== undefined) {
              jsonResponse["results"] = jsonResponse["results"].map((item) => {
                if (item.in_top_3 === true) {
                  item.in_top_3 = "Да";
                } else if (item.in_top_3 === null) {
                  item.in_top_3 = "Нет";
                } else {
                  item.in_top_3 = "Нет";
                }
                if (item.in_top_10 === true) {
                  item.in_top_10 = "Да";
                } else if (item.in_top_10 === null) {
                  item.in_top_10 = "Нет";
                } else {
                  item.in_top_10 = "Нет";
                }

                delete item.in_top_3_other;
                delete item.in_top_10_other;

                return item;
              });
              commit("updateRowsPaginationNumber", jsonResponse["count"]);
              jsonResponse.date = dateRange;
              rowDate.push(dateRange);

              jsonResponse["keywordsStats"] = jsonResponse["results"];
              delete jsonResponse["results"];
              if (jsonResponse["keywordsStats"].length > 0) {
                tableTitle[1] = `по ${sliceParam} за период `;
                commit("updatePushReportsRowsTitles", tableTitle);
                commit("updateReportRowsDates", rowDate);
                commit("updatePushReportRowsDates", rowDate);
              }
            } else {
              jsonResponse = [];
              dispatch("selectTableThumblersHolding", true);
            }
            commit("updateReport", jsonResponse);
            commit("updatePushSliceParams", sliceParam);
            rowDate.push(dateRangeModified);
            reportSlice = jsonResponse;
            reportSlice["slice_param"] = params.slice_param.toLowerCase();
            reportSlice["slice_url"] = params.slice_url;
          } else {
            rowDate.push(dateRangeModified);
            let jsonResponseComparing = await studObj.sendRequest(
              "getOrganicKeywords",
              rootGetters["currentProjectId"],
              "?" +
                dateRangeString +
                "&" +
                dateRangeComparingString +
                "&is_sliced_data=true" +
                params.query.join() +
                filterMainPeriod +
                advertiser
            );
            let keywordDownloadComparingLink = `${
              rootGetters["currentProjectId"]
            }?${dateRangeString}&${dateRangeComparingString}&is_sliced_data=true&page=${
              getters["currentPaginationPage"]
            }${params.query.join()}${filterMainPeriod}`;
            commit(
              "updatePushKeywordsOrganicLink",
              keywordDownloadComparingLink
            );
            if (jsonResponseComparing !== undefined) {
              jsonResponseComparing["results"] = jsonResponseComparing[
                "results"
              ].map((item) => {
                if (item.in_top_3 === true) {
                  item.in_top_3 = "Да";
                } else if (item.in_top_3 === null) {
                  item.in_top_3 = "Нет";
                } else {
                  item.in_top_3 = "Нет";
                }
                if (item.in_top_10 === true) {
                  item.in_top_10 = "Да";
                } else if (item.in_top_10 === null) {
                  item.in_top_10 = "Нет";
                } else {
                  item.in_top_10 = "Нет";
                }
                if (item.in_top_3_other === true) {
                  item.in_top_3_other = "Да";
                } else if (item.in_top_3_other === null) {
                  item.in_top_3_other = "Нет";
                } else {
                  item.in_top_3_other = "Нет";
                }
                if (item.in_top_10_other === true) {
                  item.in_top_10_other = "Да";
                } else if (item.in_top_10_other === null) {
                  item.in_top_10_other = "Нет";
                } else {
                  item.in_top_10_other = "Нет";
                }

                return item;
              });
              commit(
                "updateRowsPaginationNumber",
                jsonResponseComparing["count"]
              );
              let dateRangeComparingModified = `${dateRangeComparing.slice(
                0,
                5
              )} -${dateRangeComparing.slice(12)}`;
              jsonResponseComparing.date = dateRangeModified;
              jsonResponseComparing.date_comparing = dateRangeComparingModified;
              jsonResponseComparing["keywordsStatsComparing"] =
                jsonResponseComparing["results"];
              let reportComparing = jsonResponseComparing;
              rowDate.push(`и ${dateRangeComparingModified}`);
              delete jsonResponseComparing["results"];
              commit("updateReportComparing", jsonResponseComparing);
              reportSlice = reportComparing;
              reportSlice["slice_param"] = params.slice_param.toLowerCase();
              reportSlice["slice_url"] = params.slice_url;
              if (jsonResponseComparing["keywordsStatsComparing"].length > 0) {
                tableTitle[1] = `по ${sliceParam} за периоды `;
                commit("updatePushReportsRowsTitles", tableTitle);
                commit("updatePushReportRowsDates", rowDate);
              }
            } else {
              reportSlice = [];
              dispatch("selectTableThumblersHolding", true);
            }
            // commit("updateReportsRowsTitles", []);
            // commit("updatePushReportsRowsTitles", tableTitle);
          }
          commit("updatePushReportsRows", reportSlice);
        }
      } else {
        commit("updatePageItems", noSlicePageItems);
        let tableTitle = ["Статистика по ключевым словам", "за период "];
        let rowDate = [];
        let dateRangeModified = dateRange;
        if (rootGetters["filters/comparingState"]) {
          dateRangeModified = `${dateRange.slice(0, 5)} -${dateRange.slice(
            12
          )}`;
        }
        rowDate.push(dateRangeModified);
        commit("updateReportsRows", []);
        // Second async request for Keyword Stats Response
        if (!rootGetters["filters/comparingState"]) {
          let jsonResponse = await studObj.sendRequest(
            "getOrganicKeywords",
            rootGetters["currentProjectId"],
            getters["keywordsDownloadLink"] +
              paginationPage +
              filterMainPeriodTrue +
              rootGettersAdvertisersParam +
              advertiser
          );
          let keywordDownloadLink = `${rootGetters["currentProjectId"]}${getters["keywordsDownloadLink"]}${rootGettersAdvertisersParam}&page=${getters["currentPaginationPage"]}${filterMainPeriodTrue}`;
          commit("updatePushKeywordsOrganicLink", keywordDownloadLink);
          if (jsonResponse !== undefined) {
            jsonResponse["results"] = jsonResponse["results"].map((item) => {
              if (item.in_top_3) {
                item.in_top_3 = "Да";
              } else if (item.in_top_3 === null) {
                item.in_top_3 = "Нет";
              } else {
                item.in_top_3 = "Нет";
              }
              if (item.in_top_10) {
                item.in_top_10 = "Да";
              } else if (item.in_top_10 === null) {
                item.in_top_10 = "Нет";
              } else {
                item.in_top_10 = "Нет";
              }

              delete item.in_top_3_other;
              delete item.in_top_10_other;

              return item;
            });
            commit("updateRowsPaginationNumber", jsonResponse["count"]);
            jsonResponse.date = dateRangeModified;
            commit("updatePushReportsRowsTitles", tableTitle);
            jsonResponse["keywordsStats"] = jsonResponse["results"];
            delete jsonResponse["results"];
          } else {
            jsonResponse = [];
            dispatch("selectTableThumblersHolding", true);
          }
          commit("updateReport", jsonResponse);
          commit("updatePushReportsRows", jsonResponse);
        } else {
          tableTitle[1] = "за периоды ";
          let jsonResponseComparing = await studObj.sendRequest(
            "getOrganicKeywords",
            rootGetters["currentProjectId"],
            getters["keywordsDownloadComparingLink"] +
              paginationPage +
              filterMainPeriod +
              rootGettersAdvertisersParam +
              advertiser
          );
          let keywordDownloadComparingLink = `${rootGetters["currentProjectId"]}${getters["keywordsDownloadComparingLink"]}${rootGettersAdvertisersParam}&page=${getters["currentPaginationPage"]}${filterMainPeriod}`;
          commit("updatePushKeywordsOrganicLink", keywordDownloadComparingLink);
          if (jsonResponseComparing !== undefined) {
            jsonResponseComparing["results"] = jsonResponseComparing[
              "results"
            ].map((item) => {
              if (item.in_top_3 === true) {
                item.in_top_3 = "Да";
              } else if (item.in_top_3 === null) {
                item.in_top_3 = "Нет";
              } else {
                item.in_top_3 = "Нет";
              }
              if (item.in_top_10 === true) {
                item.in_top_10 = "Да";
              } else if (item.in_top_10 === null) {
                item.in_top_10 = "Нет";
              } else {
                item.in_top_10 = "Нет";
              }
              if (item.in_top_3_other === true) {
                item.in_top_3_other = "Да";
              } else if (item.in_top_3_other === null) {
                item.in_top_3_other = "Нет";
              } else {
                item.in_top_3_other = "Нет";
              }
              if (item.in_top_10_other === true) {
                item.in_top_10_other = "Да";
              } else if (item.in_top_10_other === null) {
                item.in_top_10_other = "Нет";
              } else {
                item.in_top_10_other = "Нет";
              }

              return item;
            });
            commit(
              "updateRowsPaginationNumber",
              jsonResponseComparing["count"]
            );
            let dateRangeComparingModified = `${dateRangeComparing.slice(
              0,
              5
            )} -${dateRangeComparing.slice(12)}`;
            jsonResponseComparing.date = dateRangeModified;
            jsonResponseComparing.date_comparing = dateRangeComparingModified;
            rowDate[0] += ` и ${dateRangeComparingModified}`;
            commit("updatePushReportsRowsTitles", tableTitle);
            jsonResponseComparing["keywordsStatsComparing"] =
              jsonResponseComparing["results"];
            delete jsonResponseComparing["results"];
          } else {
            jsonResponseComparing = [];
            dispatch("selectTableThumblersHolding", true);
          }
          commit("updateReportComparing", jsonResponseComparing);
          commit("updatePushReportsRows", jsonResponseComparing);
        }
        commit("updateReportRowsDates", rowDate);
      }
      commit("updateLoadingTable", false);
    },

    selectFilterBy({ commit }, filterBy) {
      if (filterBy.value !== "mean_position") {
        commit("updateTopPersistenceFilterValue", null);
        commit("updateTopPersistenceFilterTypeOptions", topPositionTypeOptions);
        commit("updateTopPersistenceFilterType", defaultTopPositionTypeOption);
      } else {
        commit(
          "updateTopPersistenceFilterTypeOptions",
          meanPositionTypeOptions
        );
        commit("updateTopPersistenceFilterType", defaultMeanPositionTypeOption);
      }
      commit("updateFilterBy", filterBy);
    },
    selectTopPersistenceFilterType({ commit }, topPersistenceFilterType) {
      commit("updateTopPersistenceFilterType", topPersistenceFilterType);
    },
    selectTopPersistenceFilterValue({ commit }, topPersistenceFilterValue) {
      commit("updateTopPersistenceFilterValue", topPersistenceFilterValue);
    },
    selectTopPersistenceFilterTypeOptions(
      { commit },
      topPersistenceFilterTypeOptions
    ) {
      commit(
        "updateTopPersistenceFilterTypeOptions",
        topPersistenceFilterTypeOptions
      );
    },
    selectOnePeriod({ commit }, onePeriod) {
      commit("updateOnePeriod", onePeriod);
    },
    selectResetStatus({ commit }, resetStatus) {
      commit("updateResetStatus", resetStatus);
    },
    selectOnePeriodValue({ commit }, onePeriod) {
      commit("updateOnePeriodValue", onePeriod);
    },
    selectTableThumblersHolding({ commit }, tableThumblersHolding) {
      commit("updateTableThumblersHolding", tableThumblersHolding);
    },
    selectPaginationPageNumber({ commit }, paginationPageNumber) {
      commit("updatePaginationPageNumber", paginationPageNumber);
    },
    selectCurrentPaginationPage({ commit }, currentPaginationPage) {
      commit("updateCurrentPaginationPage", currentPaginationPage);
    },
    selectCurrentSlicePaginationPage({ commit }, currentSlicePagination) {
      commit("updateCurrentSlicePaginationPage", currentSlicePagination);
    },
    selectComparingValueTable({ commit }, comparingValueTable) {
      commit("updateComparingValueTable", comparingValueTable);
    },
  },
  mutations: {
    updateKeywordsStats(state, keywordsStats) {
      state.keywordsStats = keywordsStats;
    },
    updateKeywordsStatsComparing(state, keywordsStats) {
      state.keywordsStatsComparing = keywordsStats;
    },
    updateLoadingTable(state, loading) {
      state.loadingTable = loading;
    },
    updateFilterBy(state, filterBy) {
      state.filterBy = filterBy;
    },
    updateReport(state, report) {
      state.keywordsStats = report;
    },
    updateReportComparing(state, report) {
      state.keywordsStatsComparing = report;
    },
    updatePushReportsRows(state, report) {
      state.reportsRows.push(report);
    },
    updateReportsRowsTitles(state, report) {
      state.reportsRowsTitles = report;
    },
    updatePushReportsRowsTitles(state, report) {
      state.reportsRowsTitles.push(report.join(" "));
    },
    updateReportRowsDates(state, report) {
      state.reportRowsDates = report;
    },
    updatePushReportRowsDates(state, report) {
      state.reportRowsDates.push(report.join(" "));
    },
    updateSliceParams(state, report) {
      state.sliceParams = report;
    },
    updatePushSliceParams(state, report) {
      state.sliceParams.push(report);
    },
    updateReportsRows(state, report) {
      state.reportsRows = report;
    },
    updateKeywordsStatsPeriod(state, keywordsStatsPeriod) {
      state.keywordsStatsPeriod = keywordsStatsPeriod;
    },
    updateSlice(state, slice) {
      state.slice = slice;
    },
    updateTopPersistenceFilterType(state, topPersistenceFilterType) {
      if (
        topPersistenceFilterType !== null &&
        (state.topPersistenceFilterValue !== null ||
          topPersistenceFilterType.title === "Больше")
      ) {
        if (state.filterBy.value === "mean_position") {
          if (state.topPersistenceFilterType.title === "Больше") {
            topPersistenceFilterType.value = "mean_position_gt";
          } else {
            topPersistenceFilterType.value = "mean_position_lt";
          }
          // state.topPersistenceFilterValue = "";
        } else if (state.filterBy.value === "in_top_3") {
          if (topPersistenceFilterType.title === "Больше") {
            topPersistenceFilterType = {
              title: "Больше",
              value: "mean_position_gt",
            };
            state.topPersistenceFilterValue = "";
          } else if (topPersistenceFilterType.title === "Да") {
            topPersistenceFilterType = {
              title: "Да",
              value: "in_top_3",
            };
            state.topPersistenceFilterValue = JSON.stringify(true);
          } else {
            topPersistenceFilterType = {
              title: "Нет",
              value: "in_top_3",
            };
            state.topPersistenceFilterValue = JSON.stringify(false);
          }
        } else if (state.filterBy.value === "in_top_10") {
          if (topPersistenceFilterType.title === "Больше") {
            topPersistenceFilterType = {
              title: "Больше",
              value: "mean_position_gt",
            };
            state.topPersistenceFilterValue = "";
          } else if (topPersistenceFilterType.title === "Да") {
            topPersistenceFilterType = {
              title: "Да",
              value: "in_top_10",
            };
            state.topPersistenceFilterValue = JSON.stringify(true);
          } else {
            topPersistenceFilterType = {
              title: "Нет",
              value: "in_top_10",
            };
            state.topPersistenceFilterValue = JSON.stringify(false);
          }
        }
      }
      state.topPersistenceFilterType = topPersistenceFilterType;
      if (
        state.topPersistenceFilterValue === null ||
        state.topPersistenceFilterValue === ""
      ) {
        state.topPersistenceFilterValue = "";
      }
    },
    updateTopPersistenceFilterValue(state, topPersistenceFilterValue) {
      state.topPersistenceFilterValue = topPersistenceFilterValue;
    },
    updateTopPersistenceFilterTypeOptions(
      state,
      topPersistenceFilterTypeOptions
    ) {
      state.topPersistenceFilterTypeOptions = topPersistenceFilterTypeOptions;
    },
    updateOnePeriod(state, onePeriod) {
      state.onePeriod = onePeriod;
    },
    updateResetStatus(state, resetStatus) {
      state.resetStatus = resetStatus;
    },
    updateOnePeriodValue(state, onePeriodValue) {
      state.onePeriodValue = onePeriodValue;
    },
    updateTableThumblersHolding(state, tableThumblersHolding) {
      state.tableThumblersHolding = tableThumblersHolding;
    },
    updatePaginationPageNumber(state, paginationPageNumber) {
      state.paginationPageNumber = paginationPageNumber;
    },
    updatePageItems(state, pageItems) {
      state.pageItems = pageItems;
    },
    updateCurrentPaginationPage(state, currentPaginationPage) {
      state.currentPaginationPage = currentPaginationPage;
    },
    updateCurrentSlicePaginationPage(state, currentSlicePagination) {
      state.slicePaginationPage[currentSlicePagination[0]] =
        currentSlicePagination[1];
    },
    updateRowsPaginationNumber(state, rowsPaginationNumber) {
      state.rowsPaginationNumber = rowsPaginationNumber;
    },
    updateDownloadKeywordsOrganicLink(state, downloadKeywordsOrganicLink) {
      state.downloadKeywordsOrganicLink = downloadKeywordsOrganicLink;
    },
    updatePushKeywordsOrganicLink(state, keywordsOrganicLink) {
      if (!state.downloadKeywordsOrganicLink.includes(keywordsOrganicLink)) {
        state.downloadKeywordsOrganicLink.push(keywordsOrganicLink);
      }
    },
    updateFirstAdvertiser(state, firstAdvertiser) {
      state.firstAdvertiser = firstAdvertiser;
    },
    updateComparingValueTable(state, comparingValueTable) {
      state.comparingValueTable = comparingValueTable;
    },
    updateSlicePagination(state, slicePagination) {
      state.slicePagination = slicePagination;
    },
  },
  getters: {
    report_rows(state) {
      if (state.reportsRows.length) {
        let reportRows = [];
        for (let response in state.reportsRows) {
          let rows = [];
          if (
            (state.reportsRows[response].keywordsStatsComparing !== undefined &&
              state.reportsRows[response].keywordsStatsComparing.length === 0 &&
              state.reportsRows[response].keywordsStats === undefined) ||
            (state.reportsRows[response].keywordsStats !== undefined &&
              state.reportsRows[response].keywordsStats.length === 0 &&
              state.reportsRows[response].keywordsStatsComparing === undefined)
          ) {
            continue;
          }
          if (
            (state.reportsRows[response].keywordsStats !== undefined &&
              state.reportsRows[response].keywordsStats.length > 0) ||
            (state.reportsRows[response].keywordsStatsComparing !== undefined &&
              state.reportsRows[response].keywordsStatsComparing.length > 0)
          ) {
            if (state.reportsRows[response].date_comparing) {
              state.reportsRows[response].keywordsStats = [];
              rows.push({
                keyword_name: "",
                ad_url_full: "",
                mean_position: shortenizeYearFormat(
                  state.reportsRows[response].date
                ),
                mean_positionComparing: shortenizeYearFormat(
                  state.reportsRows[response].date_comparing
                ),
                mean_position_delta: "Изменение ср. позиции",
                in_top_3: shortenizeYearFormat(
                  state.reportsRows[response].date
                ),
                in_top_3Comparing: shortenizeYearFormat(
                  state.reportsRows[response].date_comparing
                ),
                in_top_10: shortenizeYearFormat(
                  state.reportsRows[response].date
                ),
                in_top_10Comparing: shortenizeYearFormat(
                  state.reportsRows[response].date_comparing
                ),
              });
              for (let reportComparing in state.reportsRows[response]
                .keywordsStatsComparing) {
                let meanPositionDelta = "0%";

                if (
                  state.reportsRows[response].keywordsStatsComparing[
                    reportComparing
                  ]["diff"] !== 0
                ) {
                  meanPositionDelta = `${state.reportsRows[response].keywordsStatsComparing[reportComparing]["diff"]}%`;
                }

                if (
                  state.reportsRows[response].keywordsStatsComparing[
                    reportComparing
                  ]["mean_position"] === null
                ) {
                  state.reportsRows[response].keywordsStatsComparing[
                    reportComparing
                  ]["mean_position"] = "-";
                }

                if (
                  state.reportsRows[response].keywordsStatsComparing[
                    reportComparing
                  ]["mean_position_other"] === null
                ) {
                  state.reportsRows[response].keywordsStatsComparing[
                    reportComparing
                  ]["mean_position_other"] = "-";
                }

                state.reportsRows[response].keywordsStats.push(
                  Object.assign({
                    keyword_name:
                      state.reportsRows[response].keywordsStatsComparing[
                        reportComparing
                      ]["keyword_name"],
                    ad_url_full:
                      state.reportsRows[response].keywordsStatsComparing[
                        reportComparing
                      ]["ad_url_full"],
                    mean_position:
                      state.reportsRows[response].keywordsStatsComparing[
                        reportComparing
                      ]["mean_position"],
                    mean_positionComparing:
                      state.reportsRows[response].keywordsStatsComparing[
                        reportComparing
                      ]["mean_position_other"],
                    mean_position_delta: meanPositionDelta,
                    in_top_3:
                      state.reportsRows[response].keywordsStatsComparing[
                        reportComparing
                      ]["in_top_3"],
                    in_top_3Comparing:
                      state.reportsRows[response].keywordsStatsComparing[
                        reportComparing
                      ]["in_top_3_other"],
                    in_top_10:
                      state.reportsRows[response].keywordsStatsComparing[
                        reportComparing
                      ]["in_top_10"],
                    in_top_10Comparing:
                      state.reportsRows[response].keywordsStatsComparing[
                        reportComparing
                      ]["in_top_10_other"],
                  })
                );
              }
            }
            if (
              (state.slice && !state.reportsRows[response].date_comparing) ||
              (!state.slice && !state.reportsRows[response].date_comparing)
            ) {
              rows.push({
                keyword_name: "",
                ad_url_full: "",
                mean_position: shortenizeYearFormat(
                  state.reportsRows[response].date
                ),
                in_top_3: shortenizeYearFormat(
                  state.reportsRows[response].date
                ),
                in_top_10: shortenizeYearFormat(
                  state.reportsRows[response].date
                ),
              });
            }
          }
          rows = rows.concat(state.reportsRows[response].keywordsStats);
          reportRows.push({
            rows: [...new Set(rows)],
            slice_param: state.reportsRows[response]["slice_param"],
            count: state.reportsRows[response]["count"],
            slice_url: state.reportsRows[response]["slice_url"],
          });
        }
        return reportRows;
      }
      return [];
    },

    reportRowsTitles(state) {
      return state.reportsRowsTitles.filter(
        (value, index, array) => array.indexOf(value) === index
      );
    },

    reportRowsDates(state) {
      return state.reportRowsDates;
    },

    keywordsStats(state) {
      return state.keywordsStats;
    },
    topPersistenceFilterType(state) {
      return state.topPersistenceFilterType;
    },
    topPersistenceFilterTypeOptions(state) {
      return state.topPersistenceFilterTypeOptions;
    },
    topPersistenceFilterValue(state) {
      return state.topPersistenceFilterValue;
    },
    keywordsStatsPeriod(state) {
      return state.keywordsStatsPeriod;
    },
    keywordsDownloadLink(state, getters, rootState, rootGetters) {
      let keywordsLink =
        "?" +
        rootGetters["filters/dateRangeParam"] +
        rootGetters["filters/searchEngineParam"] +
        rootGetters["filters/deviceTypesParam"] +
        rootGetters["filters/keywordsParam"] +
        rootGetters["filters/keywordsTypesParam"] +
        rootGetters["filters/geoLocationsParam"];
      if (state.topPersistenceFilterValue && state.topPersistenceFilterType) {
        keywordsLink += `&${state.topPersistenceFilterType["value"]}=${state.topPersistenceFilterValue}`;
      }
      return keywordsLink;
    },
    keywordsDownloadLinkWithPage(state, getters, rootState, rootGetters) {
      let downloadLink =
        "?" +
        rootGetters["filters/dateRangeParam"] +
        rootGetters["filters/searchEngineParam"] +
        rootGetters["filters/deviceTypesParam"] +
        rootGetters["filters/keywordsParam"] +
        rootGetters["filters/keywordsTypesParam"] +
        rootGetters["filters/geoLocationsParam"] +
        rootGetters["filters/advertisersParam"];
      if (state.topPersistenceFilterValue && state.topPersistenceFilterType) {
        downloadLink += `&${state.topPersistenceFilterType["value"]}=${state.topPersistenceFilterValue}`;
      }

      downloadLink += `&page=${state.currentPaginationPage}`;

      return downloadLink;
    },
    keywordsDownloadComparingLink(state, getters, rootState, rootGetters) {
      let keywordsLink =
        "?" +
        rootGetters["filters/dateRangeParam"] +
        "&" +
        rootGetters["filters/dynamicDashboardParams"] +
        rootGetters["filters/searchEngineParam"] +
        rootGetters["filters/deviceTypesParam"] +
        rootGetters["filters/keywordsParam"] +
        rootGetters["filters/keywordsTypesParam"] +
        rootGetters["filters/geoLocationsParam"];
      // if (state.) {}
      if (state.topPersistenceFilterValue && state.topPersistenceFilterType) {
        keywordsLink += `&${state.topPersistenceFilterType["value"]}=${state.topPersistenceFilterValue}`;
      }
      return keywordsLink;
    },
    keywordsDownloadComparingLinkWithPage(
      state,
      getters,
      rootState,
      rootGetters
    ) {
      let downloadComparingLink =
        "?" +
        rootGetters["filters/dateRangeParam"] +
        rootGetters["filters/searchEngineParam"] +
        rootGetters["filters/deviceTypesParam"] +
        rootGetters["filters/keywordsParam"] +
        rootGetters["filters/keywordsTypesParam"] +
        rootGetters["filters/geoLocationsParam"] +
        rootGetters["filters/advertisersParam"];
      if (state.topPersistenceFilterValue && state.topPersistenceFilterType) {
        downloadComparingLink += `&${state.topPersistenceFilterType["value"]}=${state.topPersistenceFilterValue}`;
      }

      downloadComparingLink += `&page=${state.currentPaginationPage}`;

      return downloadComparingLink;
    },
    filterTableLink(state) {
      let keywordsLink = "";
      if (state.topPersistenceFilterValue && state.topPersistenceFilterType) {
        keywordsLink += `&${state.topPersistenceFilterType["value"]}=${state.topPersistenceFilterValue}`;
      }
      return keywordsLink;
    },
    filterBy(state) {
      return state.filterBy;
    },
    filterByOptions(state) {
      return state.filterByOptions;
    },
    loadingTable(state) {
      return state.loadingTable;
    },
    onePeriod(state) {
      return state.onePeriod;
    },
    onePeriodValue(state) {
      return state.onePeriodValue;
    },
    resetStatus(state) {
      return state.resetStatus;
    },
    tableThumblersHolding(state) {
      return state.tableThumblersHolding;
    },
    paginationPageNumber(state) {
      return state.paginationPageNumber;
    },
    pageItems(state) {
      return state.pageItems;
    },
    currentPaginationPage(state) {
      return state.currentPaginationPage;
    },
    rowsPaginationNumber(state) {
      return state.rowsPaginationNumber;
    },
    downloadKeywordsOrganicLink(state) {
      return state.downloadKeywordsOrganicLink;
    },
    firstAdvertiser(state) {
      return state.firstAdvertiser;
    },
    comparingValueTable(state) {
      return state.comparingValueTable;
    },
    slicePaginationPage(state) {
      return state.slicePaginationPage;
    },
  },
};
